import React from "react";
import {
  FaUserFriends,
  FaVideo,
  FaWallet,
  FaHeadset,
  FaStar,
  FaShieldAlt,
  FaLock,
  FaRupeeSign,
  FaUsers,
  FaCheckCircle,
} from "react-icons/fa";


const BENEFITS = [
  {
    icon: FaUserFriends,
    title: "Daily Customer Leads",
    desc: "Get more clients every day",
  },
  {
    icon: FaVideo,
    title: "Chat & Call Consultation",
    desc: "Connect instantly with users",
  },
  {
    icon: FaWallet,
    title: "Monthly Payouts",
    desc: "Secure and timely payments",
  },
  {
    icon: FaHeadset,
    title: "24×7 Support",
    desc: "Dedicated partner assistance",
  },
];

const WHY_POINTS = [
  { icon: FaShieldAlt, label: "100% Verified Astrologers" },
  { icon: FaLock, label: "Secure & Private Platform" },
  { icon: FaRupeeSign, label: "Timely Payouts" },
  { icon: FaUsers, label: "Growing Network Every Day" },
];

// const AVATARS = [
//   "https://randomuser.me/api/portraits/women/68.jpg",
//   "https://randomuser.me/api/portraits/men/32.jpg",
//   "https://randomuser.me/api/portraits/women/44.jpg",
// ];
const AVATARS = [
  "/astrologer-register1.png",
  "/astrologer-register2.png",
  "/astrologer-register3.png",
];

export default function AstrologerMarketingPanel() {
  return (
    <aside className="ao-marketing">
      <p className="ao-marketing__badge">
        <FaStar size={10} aria-hidden />
        Join AstroCall as a Verified Astrologer
      </p>

      <h1 className="ao-marketing__title">
        Become a Verified
        <br />
        <span className="ao-marketing__title-accent">Astrologer Partner</span>
      </h1>

      <p className="ao-marketing__desc">
        Join thousands of professional astrologers. Chat &amp; Call Consult with users
        across India and grow your astrology business.
      </p>

      <div className="ao-benefits">
        {BENEFITS.map(({ icon: Icon, title, desc }) => (
          <article key={title} className="ao-benefit">
            <span className="ao-benefit__icon ao-benefit__icon--solid">
              <Icon size={15} aria-hidden />
            </span>
            <div className="ao-benefit__text">
              <p className="ao-benefit__title">{title}</p>
              <p className="ao-benefit__desc">{desc}</p>
            </div>
          </article>
        ))}
      </div>

      <div className="ao-social-proof">
        <div className="ao-social-proof__left">
          <div className="ao-social-proof__avatars" aria-hidden>
            {/* {AVATARS.map((src) => (
              <img key={src} src={src} alt="" className="ao-social-proof__avatar" />
            ))} */}
            {AVATARS.map((src) => (
              <img
                key={src}
                src={src}
                alt=""
                className="ao-social-proof__avatar"
              />
            ))}
          </div>
          <div className="ao-social-proof__copy">
            <p className="ao-social-proof__title">500+ Astrologers</p>
            <p className="ao-social-proof__sub">Already joined AstroCall</p>
          </div>
        </div>

        <div className="ao-social-proof__divider" aria-hidden />

        <div className="ao-social-proof__trust">
          <span className="ao-social-proof__shield" aria-hidden>
            <FaCheckCircle size={18} />
          </span>
          <div>
            <p className="ao-social-proof__trust-title">Trusted by experts</p>
            <p className="ao-social-proof__trust-sub">across India</p>
          </div>
        </div>
      </div>

      <div className="ao-why-box">
        <div className="ao-why">
          <div className="ao-why__line" aria-hidden />
          <span className="ao-why__diamond" aria-hidden />
          <p className="ao-why__title">Why Astrologers choose AstroCall</p>
          <span className="ao-why__diamond" aria-hidden />
          <div className="ao-why__line" aria-hidden />
        </div>

        <div className="ao-why__grid">
          {WHY_POINTS.map(({ icon: Icon, label }) => (
            <div key={label} className="ao-why__item">
              <span className="ao-why__icon">
                <Icon size={18} aria-hidden />
              </span>
              <p>{label}</p>
            </div>
          ))}
        </div>
      </div>
    </aside>
  );
}
